import { Box } from '@mui/material';
import styled from 'styled-components';

export const AppContainer = styled(Box)(
  ({ theme }) => `
`);